module.exports = __webpack_public_path__ + "img/139.5.824386d6.png";